

import { Button, Form, Input, message, Row } from "antd";
import React from "react";
import { connect } from "react-redux";
import {
  updateFrachiseRequest
} from "../../../RestServices/videosService";
import ModalUtil from "../../../utils/Modal/Modal";

class EditFranchiseRequest extends React.Component {
  state = {
    isDeleteLoading: false,
    isDeleted: false,
    actionModal: false,
    passwordForAction: this.props.franchise.adminNotes,
  };

  deleteUser = async (evt) => {
    evt.stopPropagation();
   
    this.setState({ isDeleteLoading: true });
    try {
        await updateFrachiseRequest(
        this.props.franchise._id, {adminNotes:this.state.passwordForAction},
          this.props.Auth.user.token
        );
      
      message.success("Request Updated");
      this.setState({
        isDeleteLoading: false,
        isDeleted: true,
        actionModal: false,
      });
    } catch (err) {
      this.setState({ isDeleteLoading: false });
      if (err.response) {
        return message.error(err.response.data.message);
      }
      message.error(err.message);
    }
  };
  onCloseActionModal = (e) => {
    e.stopPropagation();
    this.props.deleteModalFuc && this.props.deleteModalFuc();

    this.setState({
      actionModal: false,
    });
  };
  openModal = (e) => {
    e.stopPropagation();
    this.props.deleteModalFuc && this.props.deleteModalFuc();
    this.setState({ actionModal: true });
  };

  componentDidMount() {
    this.setState({
      passwordForAction: this.props.franchise.adminNotes,
    })
  }

  render() {
    const {  isDeleteLoading } = this.state;
   
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <ModalUtil
          timerModalVisible={this.state.actionModal}
          timerModalLoading={isDeleteLoading}
          title={"set Rate"}
          showTimerModal={this.setActionModal}
          handleTimerModalOnOk={this.deleteUser}
          handleTimerModalOnCancle={(e) => this.onCloseActionModal(e)}
        >
          <Row style={{ margin: "20px" }} justify="center">
            <Form
              style={{ padding: "20px", width: "100%" }}
              colon={false}
              layout="vertical"
              onSubmit={this.deleteUser}
            >
              <h3>Enter your notes</h3>
              <Form.Item label="Note" required>
                <Input.TextArea
                  
                  size="large"
                  name="passwordForAction"
                  onChange={(e) =>
                    this.setState({ passwordForAction: e.target.value })
                  }
                  value={this.state.passwordForAction}
                  placeholder="Enter your notes"
                />
              </Form.Item>
            </Form>
          </Row>
        </ModalUtil>

        <Button
          style={{marginRight:"10px"}}
          type={"primary"}
          loading={isDeleteLoading}
          disabled={isDeleteLoading}
          onClick={this.openModal}
        >
          Add Note
        </Button>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  Auth: store.Authentication,
});
export default connect(mapStateToProps)(EditFranchiseRequest);
